<template>
  <div class="basket-header">
    <div class="basket-button-back" @click="closeBasket"><span class="pp-icon pp-icon-arrow"></span></div>
    <div class="basket-header-title" v-if="!isOpenOrder()">
      {{ totalQuantity }} {{ plates }} {{phrases.BASKET_SUM_IN}} {{ total_order_sum }}&#8381;
      <div class="basket-header-discount-sum" v-if="discountSum > 0">{{phrases.TEXT_DISCOUNT}} {{discountSum}}&#8381;</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import BasketUtils from "./BasketUtils";
import Utils from "../Utils";

export default {
  name: "BasketHeader",
  methods:{
    closeBasket: function () {
      if(this.isSizeMd && this.isCheckout || (!this.isUserAuthorize && this.isCheckout)){
        this.$store.dispatch({
          type: 'order/setCheckout',
          state: false,
        });
      }else {
        this.$store.dispatch({
          type: 'order/close',
        });
      }
    },
  },
  computed: {
    ...mapGetters('app', {
      phrases: 'getPhrases',
      isSizeMd: 'getIsSizeMd',
    }),
    ...mapGetters('order', {
      isCheckout: 'getIsCheckout',
      discountSum: 'getDiscountSum',
      totalQuantity: 'getTotalQuantity',
    }),
    ...mapGetters('user', {
      isUserAuthorize: 'isAuthorize',
    }),
  },
  mixins: [BasketUtils, Utils],
}
</script>

<style scoped>

</style>